import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-special-columns-editor',
    templateUrl: './special-columns-editor.component.html',
    standalone: false
})
export class SpecialColumnsEditorComponent {
  // Available physical source columns: objects with { name, type } (type may be string or number).
  @Input() columns: any[] = [];
  @Input() specialColumns: any[] = [];
  @Output() specialColumnsChange = new EventEmitter<any[]>();

  // Only show validation messages after an Apply attempt; cleared on any edit.
  showErrors = false;

  get sourceColumns(): any[] {
    return (this.columns || []).filter(c => c?.name && !c?.flux && !c?.special);
  }

  isDateColumn(name: string): boolean {
    const col = (this.columns || []).find(c => c?.name === name);
    return !!col && String(col.type) === '4';
  }

  // A special column needs a non-empty name and at least one source with a selected column.
  isInvalid(sc: any): boolean {
    const nameOk = !!(sc?.name && sc.name.trim());
    const sourceOk = (sc?.sources || []).some(s => s && s.name);
    return !(nameOk && sourceOk);
  }

  // Called by parent forms on Apply. Returns false (and reveals inline messages) if any column is incomplete.
  validate(): boolean {
    this.showErrors = true;
    return (this.specialColumns || []).every(sc => !this.isInvalid(sc));
  }

  // Edit handler used by the template: clear error display and propagate the change.
  notifyChange() {
    this.showErrors = false;
    this.specialColumnsChange.emit(this.specialColumns);
  }

  private emit() {
    this.showErrors = false;
    this.specialColumnsChange.emit(this.specialColumns);
  }

  addColumn() {
    this.specialColumns = [...(this.specialColumns || []), { name: '', separator: '', sources: [] }];
    this.emit();
  }

  removeColumn(ci: number) {
    this.specialColumns.splice(ci, 1);
    this.emit();
  }

  addSource(ci: number) {
    this.specialColumns[ci].sources.push({ name: '', datePart: 'year' });
    this.emit();
  }

  removeSource(ci: number, si: number) {
    this.specialColumns[ci].sources.splice(si, 1);
    this.emit();
  }

  onSourceColumnChange(ci: number, si: number) {
    const src = this.specialColumns[ci].sources[si];
    if (this.isDateColumn(src.name) && !src.datePart) {
      src.datePart = 'year';
    }
    this.emit();
  }
}
